import { inject } from '@angular/core';
import { SsoUserApiService } from '@api-client/sso-user.api';
import { SENDING_TYPES } from '@shared/model/virtual-printer-models/virtual-printer-new.model';
import { PrinterQueryParam } from '@shared/model/vitual-printer-driver.type';
import { filter, firstValueFrom, forkJoin, of, switchMap, take, tap } from 'rxjs';
import { AppService } from './services/app.service';
import { AuthentificationService } from './services/authentification/authentification.service';
import { WafChallengeService } from './services/challenge/waf-challenge.service';
import { AppSettingsService } from './services/settings/settings.service';
import { UserService } from './services/user/user.service';

export async function initializeApp() {
  const authentificationService = inject(AuthentificationService);
  const ssoService = inject(SsoUserApiService);
  const userService = inject(UserService);
  const appService = inject(AppService);
  const wafChallengeService = inject(WafChallengeService);
  const appSettingsService = inject(AppSettingsService);

  await appSettingsService.load();
  handleVirtualPrinterRequest(authentificationService);
  wafChallengeService.loadScript();
  return await firstValueFrom(
    authentificationService.refreshToken().pipe(
      switchMap((success) => {
        if (success) {
          return forkJoin([loadAccessRights(ssoService, userService), appService.loadOptions()]);
        }
        return of(success);
      }),
    ),
  );
}

function loadAccessRights(ssoService: SsoUserApiService, userService: UserService) {
  return ssoService.checkSSOUser(userService.userMail()).pipe(
    take(1),
    filter((data) => data['url_access_rights'] !== ''),
    tap((data) => userService.setAccessRights(data)),
  );
}

function handleVirtualPrinterRequest(authentificationService: AuthentificationService) {
  const urlParams = new URLSearchParams(window.location.search);
  const guid = urlParams.get(PrinterQueryParam.Guid);
  const token = urlParams.get(PrinterQueryParam.Token);
  const refreshToken = urlParams.get(PrinterQueryParam.RefreshToken);
  const plis = urlParams.get(PrinterQueryParam.Plis);
  const sendType =
    urlParams.get(PrinterQueryParam.Physical) === '1' ? SENDING_TYPES.PHYSIQUE : SENDING_TYPES.ELECTRONIQUE;
  const isMulti = urlParams.get(PrinterQueryParam.IsMulti) === '1' && sendType === SENDING_TYPES.PHYSIQUE;
  if (guid?.length && token?.length) {
    authentificationService.virtualPrinterDriverRequest.set({
      token,
      refreshToken,
      guid,
      isMulti,
      sendType,
      plis: !isNaN(+plis) ? +plis : 0,
    });
  }
}
